<form [formGroup]="form">
    <div *ngIf="!transferSuccess && !transferError">
        <h3>
            Confirmá tu transferencia de puntos
        </h3>
        <p class="complete-transfer">
            Vas a transferir {{ transferForm.get("pointsValue")?.value }} {{ transferForm.get("pointsValue")?.value ===
            1 ? "punto" : "puntos" }} a {{ destinatario }}. Si estás de acuerdo introducí el codigo que te envíamos a tu correo electrónico  al *******.com
        </p>

        <div class="confirmation-code" [formGroup]="validationForm">
            <input *ngFor="let control of inputControls; let i = index" type="text" maxlength="1"  #inputField
                class="confirmation-input"  [formControlName]="control"
                (keyup)="onKeyUp($event, i)"
                (keydown)="onKeyDown($event, i)"
                (paste)="paste.emit($event)" />
        </div>

        <div class="container-timer" *ngIf="!showRevalidate">
            <div class="timer">
                <p *ngIf="countdown > 0; else noCountdown">
                    Solicitá nuevo código en: {{ countdown | countdown }}
                </p>
                  <ng-template #noCountdown>
                    <p class="no-countdown">Tu código expiró, pero no te preocupes, puedes pedir uno nuevo con este botón.</p>
                  </ng-template>
            </div>

        <button (click)="resend.emit()" [disabled]="countdown !== 0"
            [ngStyle]="{ opacity: countdown === 0 ? '1' : '0.5' }">
            Reenviar código
        </button>

        </div>


        <p *ngIf="showError.length > 0" class="error">
            {{ showError }}
        </p>


        <div class="buttons-container" *ngIf="!loading">
            <button class="cancelBtn" (click)="cancel.emit()">Cancelar</button>
            <button class="btn-confirm" (click)="confirm.emit()" 
            [style.opacity]="!(isErrorConfirmed === false && validationForm.invalid === false) ? '0.5' : '1'" 
            [style.cursor]="!(isErrorConfirmed === false && validationForm.invalid === false) ? 'pointer' : ''"
            [disabled]="!(isErrorConfirmed === false && validationForm.invalid === false)">Aceptar</button>
        </div>

        <ng-container *ngIf="loading">
            <div class="spinner"></div>
        </ng-container>
        
    </div>

    <span class="transferenceLoader loader" *ngIf="loading">
        <div class="brand-shell loader"></div>
    </span>

    <div class="modalText" *ngIf="transferSuccess">
        <img src="assets/images/green-tick.png" />
        <p class="success-message">Transferencia exitosa. ¡Los puntos han sido transferidos con éxito!</p>
    </div>

    <div class="modalText" *ngIf="transferError">
        <img src="assets/images/error.png" />
        <p class="error-message">Hubo un error en la transferencia de puntos. Por favor, inténtalo de nuevo.</p>
    </div>
</form>